// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2957) return "static/chunks/2957-e6edda56946ce5e8.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4484":"fad773ac45a9e0bf","6677":"b76ae0a6467c67cf","6878":"5657c32e06476a2e","8032":"7772ad7625e0791d"}[chunkId] + ".js";
};